module.exports = __webpack_public_path__ + "static/media/booking5.6e941ff0.jpg";